import React from "react";

function RowCard(props) {
  const { data, columnWidths, mode, padding = "0px" } = props;
  // mode = "grid" | "center"

  if (mode === "grid") {
    const gridTemplateColumns = columnWidths.join(" ");
    return (
      <div
        className="rounded"
        style={{
          width: "100%",
          backgroundColor: "white",
          display: "grid",
          gridTemplateColumns,
          padding,
          fontWeight: "bold",
          gridTemplateRows: "1fr",
        }}
      >
        {data.map((column, index) => {
          return <div key={index}>{column}</div>;
        })}
      </div>
    );
  } else if (mode === "centered") {
    return (
      <div
        className="rounded"
        style={{
          width: "100%",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "space-around",
          padding,
          fontWeight: "bold",
        }}
      >
        {props.data.map((column, index) => {
          return <div key={index}>{column}</div>;
        })}
      </div>
    );
  }
}

export default RowCard;
